import { NgModule } from '@angular/core';
import { ShowDistanceRoutingModule } from './show-distance-routing.module';
@NgModule({
  imports: [
     ShowDistanceRoutingModule,
  ],
})
export class ShowDistanceModule { }

